
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/referral-delta-pro-3-portable-power-station",
      function () {
        return require("private-next-pages/referral-delta-pro-3-portable-power-station/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/referral-delta-pro-3-portable-power-station"])
      });
    }
  